module.exports = __webpack_public_path__ + "media/Video 111.e8deb5c0.mp4";